declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_legacy_value_foo extends $mol_object {
		b( next?: number ): number
		a( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_legacy_value_foo['b'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_legacy_value_foo['b'] >
	}
	
}

//# sourceMappingURL=bidi_legacy_value.view.tree.d.ts.map